// Single source of truth for the variable names that EmailTemplates and
// EmailComposer expose for {{substitution}}. Keep this in sync with
// GmailService.BuildProjectVariables on the backend.
export const TEMPLATE_VARIABLE_GROUPS = [
  {
    category: 'Customer',
    vars: [
      'customerName',
      'customerFirstName',
      'customerLastName',
      'customerDisplayName',
      'customerEmail',
      'customerPhone',
      'customerMobilePhone',
      'companyName',
    ],
  },
  {
    category: 'Tenant (PM jobs)',
    vars: [
      'tenantName',
      'tenantContact',
    ],
  },
  {
    category: 'Address',
    vars: [
      'jobAddress',
      'propertyStreet',
      'addressLine2',
      'propertyCity',
      'propertyState',
      'propertyZip',
      'gateCode',
    ],
  },
  {
    category: 'Project',
    vars: [
      'projectName',
      'projectStatus',
      'jobId',
      'poNumber',
      'jobIdentifier',
      'projectUrl',
      'projectLink',
      'leadSource',
      'currentInstaller',
    ],
  },
  {
    category: 'Insurance / Claims',
    vars: [
      'insuranceCarrier',
      'claimNumber',
      'dateOfLoss',
    ],
  },
  {
    category: 'Work Details',
    vars: [
      'shingleType',
      'shingleColor',
      'sidingColor',
    ],
  },
  {
    category: 'Gutters',
    vars: [
      'gutterGuards',
      'gutterColor',
      'gutterFeet',
      'downspoutFeet',
      'oneStoryDownspouts',
      'twoStoryDownspouts',
    ],
  },
  {
    category: 'Work Order / Notes',
    vars: [
      'workOrderType',
      'workOrderText',
      'repairDescription',
      'repairCompletionNotes',
      'notRoofRelatedNotes',
      'overviewReportNotes',
    ],
  },
  {
    category: 'Dates',
    vars: [
      'date',
      'completionDate',
      'scheduledStartDate',
      'workOrderStartDate',
      'materialDeliveryDate',
    ],
  },
  {
    category: 'Appointment (task)',
    vars: [
      'appointmentDate',
      'appointmentTime',
      'taskTitle',
    ],
  },
  {
    category: 'Sales Rep',
    vars: [
      'assignedUser',
      'salesRepName',
      'salesRepPhone',
    ],
  },
];
